import { updateTemplateUrl } from '../urls';
import { TemplateResponseDto, StrapiTemplate } from '../types';

import { HsmBackendHttpClient, HsmBackendResponse } from '@/utils/http-client';

/**
 * Update a template for a website
 * @param websiteId website that owns the template
 * @param templateName provider-native template identifier
 * @param newValues Strapi template property values
 * @returns an Strapi template
 */
async function updateTemplate(
  websiteId: string,
  templateName: string,
  newValues: Partial<TemplateResponseDto>
): Promise<StrapiTemplate> {
  const client = HsmBackendHttpClient.instance;

  const requestOptions = JSON.stringify(newValues);

  const { result: updatedTemplate } = await client.put<
    HsmBackendResponse<StrapiTemplate>
  >(updateTemplateUrl(websiteId, templateName), requestOptions);

  return updatedTemplate;
}

export default updateTemplate;
